var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInventoryDashboardSm = function SvgInventoryDashboardSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Inventory Dashboard",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 3793"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.354 9.086a1.148 1.148 0 0 1-.259-.03l-2.861 5.455a1.2 1.2 0 1 1-2.019.865c0-.038.008-.072.008-.11l-2.069-2.3a1.185 1.185 0 0 1-.655.2 1.1 1.1 0 0 1-.32-.05l-1.833 3.4a1.192 1.192 0 1 1-.952-.48 1.336 1.336 0 0 1 .3.042l1.84-3.402a1.184 1.184 0 0 1-.232-.7 1.2 1.2 0 1 1 2.328.373l1.958 2.158a1.2 1.2 0 0 1 .823-.331c.038 0 .076.008.114.011l2.907-5.543a1.192 1.192 0 1 1 .922.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.464H2V2.995h10.773v6.392a3.146 3.146 0 0 0-.836.149v-5.1a.346.346 0 0 0-.348-.343l-2.6.011a.35.35 0 0 0-.354.338v3.3l-.93-.786a.31.31 0 0 0-.217-.083.324.324 0 0 0-.227.083l-.924.786v-3.3a.35.35 0 0 0-.354-.338l-2.807-.011a.342.342 0 0 0-.342.343v7.581a.342.342 0 0 0 .342.343h4.262a2.77 2.77 0 0 0-.436 1.105z",
    "data-name": "Path 11616"
  }))));
};
export default SvgInventoryDashboardSm;